/**
 * @file DateSelection.js
 * @module src/js/components/DateSelection
 * @description
 * **A reusable date selection component for forms.**
 * - Renders dropdowns for selecting year, month, and optionally day.
 * - Year dropdown includes the last 30 years up to next year.
 * - Month dropdown includes all 12 months.
 * - Day dropdown includes all 31 days if `setDay` prop is provided.
 * - For now, whether the date is valid is the responsibility of the parent component.
 * - Supports an optional "N/A" option for month selection when `monthOptional` is true.
 *
 * @version
 * <p>
 *  2025-11-26: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-11-26: Added `monthOptional` prop for optional month selection. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-11-26: Updated year range to last 30 years up to next year. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
export default function DateSelection({
    year,
    month,
    day = '',
    setYear,
    setMonth,
    setDay = null,
    monthOptional = false
}) {
    return (
        <td className='hori-vert-center'>
            <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                style={{ marginBottom: '5px' }}
            >
                {Array.from({ length: 30 }, (_, i) => {
                    const yr = String(new Date().getFullYear() - i + 1);
                    return <option key={yr} value={yr}>{yr}</option>;
                })}
            </select>
            <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                style={{ marginBottom: '5px' }}
            >
                {Array.from({ length: 12 }, (_, i) => {
                    const mn = String(i + 1).padStart(2, '0');
                    return <option key={mn} value={mn}>{mn}</option>;
                })}
                {monthOptional && <option key='99' value='99'>N/A</option>}
            </select>
            {setDay && (
                <select
                    value={day}
                    onChange={(e) => setDay(e.target.value)}
                >
                    {Array.from({ length: 31 }, (_, i) => {
                        const dy = String(i + 1).padStart(2, '0');
                        return <option key={dy} value={dy}>{dy}</option>;
                    })}
                </select>
            )}
        </td>
    )
}